import React from "react";
import Header from "../components/Header";
import IpGeoData from "../components/IpGeoData";
import Map from "../components/Map";

const Home = () => {
  return (
    <>
      <Header />
      <IpGeoData />
      <Map />
    </>
  );
};

export default Home;
